import { setRecentlyProducts } from 'helpers/recently-product'
import register from 'preact-custom-element'
import ProductGiftCardForm from 'snippets/product-form/product-giftcard-form'

let devtools
if (process.env.NODE_ENV === 'development') {
  devtools = require('preact/devtools')
}

class ProductGiftCard extends HTMLElement {
  constructor() {
    super()
    setRecentlyProducts(this.dataset.handle)

    if (localStorage.getItem('return_to')) {
      localStorage.removeItem('return_to')
    }
  }
}

register(ProductGiftCardForm, 'product-giftcard-form')

customElements.define('product-gift-card', ProductGiftCard)
